import { onMounted, ref, useTemplateRef } from 'vue'
import { getTransitionsFromState } from '@/libs/utils/workflows.js'
import { buildPayloadAttributesMassive } from '@/libs/utils/permissions.js'

import { client } from '@/services/fetch.js'
import TranslationProvider from '@/provider/translations.js'
import ConfigurationProvider from '@/provider/configuration.js'
import { toast } from '@/services/toast.js'
import _ from 'lodash'

export const buildDropdown = (
  bulkActions
) => {
  const res = {}
  for (const [type, action] of Object.entries(bulkActions)) {
    for (const bulkAction of action) {
      if (bulkAction['workflow']) {
        if (! res[bulkAction['workflow']])
          res[bulkAction['workflow']] = {}
        if (!res[bulkAction['workflow']][type])
          res[bulkAction['workflow']][type] = []
        res[bulkAction['workflow']][type].push(bulkAction)
      } else {
        if (!res['all_wf'])
          res['all_wf'] = {}
        if (!res['all_wf'][type])
          res['all_wf'][type] = []
        res['all_wf'][type].push(bulkAction)
      }
    }
  }
  return res
}

export function useBulkActions(
  compiledPolls,
  transitionsList,
  delegateValidators = []
) {
  const bulkActionsT = useTemplateRef('bulk-action')
  const modalConfirmBulkActions = useTemplateRef('modal-confirm-bulk-actions')
  const modalBulkActions = useTemplateRef('modal-bulk-actions')

  const bulkActions = ref([])
  const modalBulkActionsPayload = ref({})
  const selectedBulkAction = ref(null)
  const selectedCps = ref([])
  const bulkTransitions = ref([])
  const bulkActionsDone = ref([])
  const modalBulkActionsLoading = ref(false)

  onMounted(() => {
    if (ConfigurationProvider.getConfig()['app']['bulkActions']['compiled_polls']) {
      bulkActions.value = ConfigurationProvider.getConfig()['app']['bulkActions']['compiled_polls']
    }
  })

  const selectAll = (e) => {
    bulkActionsT.value.forEach((item) => {
      item.checked = e.target.checked
      item.dispatchEvent(new Event('change'))
    })
  }

  const toggleSelect = (e) => {
    const obj = {
      id: e.target.getAttribute('data-cpid'),
      state: e.target.getAttribute('data-state')
    }

    if (e.target.checked) {
      let add = true
      selectedCps.value.forEach((item) => {
        if (item['id'] === obj.id) {
          add = false
        }
      })
      if (add) {
        selectedCps.value.push(obj)
      }
    } else {
      selectedCps.value.forEach((item) => {
        if (item['id'] === obj.id) {
          selectedCps.value.splice(selectedCps.value.indexOf(item), 1)
        }
      })
    }
  }

  const applyBulkTransition = async (type, action) => {

    const payload = []
    selectedCps.value.forEach((item) => {
      const transition = getTransitionsFromState(item['state'], action, transitionsList.value)
      payload.push({
        compiledPollId: item['id'],
        transition: transition,
        workflow: action.workflow
      })
    })

    const chunks = _.chunk(payload, 5)
    try {
      for (const chunk of chunks) {
        let url = `/compiled-poll/api/compiled-poll/bulk-transition`
        const res = await client.post(url, { compiledPolls: chunk }, 'application/json')
        if (res.data) {
          const data = res.data
          for (const [compiledPollId, res] of Object.entries(data)) {
            const compiledPoll = compiledPolls.value.data.find((compiledPoll) => compiledPoll['id'] === compiledPollId)
            if (res.error) {
              let message = ''
              for (let e of res.errors) {
                if (e.message) {
                  message += `${TranslationProvider.getTrans(e.message)}<br>`
                } else {
                  message += `${TranslationProvider.getTrans(e)}<br>`
                }
              }
              bulkActionsDone.value.push({ compiledPoll: compiledPoll, done: false, error: message })
            } else {
              bulkActionsDone.value.push({ compiledPoll: compiledPoll, done: true })
            }
          }
        }
      }
    } catch (e) {
      console.error(e)
      toast.create('Qualcosa è andato storto, riprova più tardi', 'error')
    }
  }

  const applyBulkDelegate = async () => {
    const payload = []
    switch (selectedBulkAction.value.action.name) {
      case 'both':
        for (const item of selectedCps.value) {
          const compiledPoll = compiledPolls.value.data.find((compiledPoll) => compiledPoll['id'] === item['id'])

          const errors = []
          for (const validator of delegateValidators) {
            let error = await validator(compiledPoll, modalBulkActionsPayload.value)
            if (error) {
              error = TranslationProvider.getTrans(error)
              if (error) {
                errors.push(error)
              }
            }
          }
          if (errors.length > 0) {
            bulkActionsDone.value.push({ compiledPoll, done: false, error: errors.join('<br>') })
            continue
          }

          const updatedCp = buildPayloadAttributesMassive(modalBulkActionsPayload.value, compiledPoll)
          payload.push({
            'compiledPollId': compiledPoll.id,
            'attributes': updatedCp['attributes'],
            'permissions': updatedCp['permissions']
          })
        }

        const chunks = _.chunk(payload, 5)

        try {
          for (const chunk of chunks) {
            const url = `/compiled-poll/api/compiled-poll/bulk-delegate`
            const res = await client.post(url, { compiledPolls: chunk }, 'application/json')
            if (res.data) {
              const data = res.data
              for (const [compiledPollId, res] of Object.entries(data)) {
                if (!res.error) {
                  const compiledPoll = compiledPolls.value.data.find((compiledPoll) => compiledPoll['id'] === compiledPollId)
                  bulkActionsDone.value.push({ compiledPoll, done: true })
                }
              }
            }
          }
        } catch (e) {
          console.error(e)
          toast.create('Qualcosa è andato storto, riprova più tardi', 'error')
        }
        break
    }
  }

  const selectBulkAction = async (type, action, confirm = false) => {
    if (!confirm) {
      modalBulkActionsPayload.value = null
      bulkActionsDone.value = []

      selectedBulkAction.value = {
        action: action,
        type: type,
        customModalContent: action['custom_modal_content'] || null,
        title: action.title || null
      }

      modalConfirmBulkActions.value.classList.add('d-block')
      return
    }

    modalConfirmBulkActions.value.classList.remove('d-block')

    switch (type) {
      case 'transitions':
        modalBulkActions.value.classList.add('d-block')
        modalBulkActionsLoading.value = true
        await applyBulkTransition(type, action)
        modalBulkActionsLoading.value = false
        selectedBulkAction.value = null
        break
      case 'delegate':
        modalBulkActions.value.classList.add('d-block')
        modalBulkActionsLoading.value = true
        await applyBulkDelegate(type, action)
        modalBulkActionsLoading.value = false
        selectedBulkAction.value = null
        break
    }
  }

  return {
    bulkActions,
    bulkActionsT,
    modalBulkActions,
    modalConfirmBulkActions,
    modalBulkActionsPayload,
    selectedBulkAction,
    selectedCps,
    bulkTransitions,
    bulkActionsDone,
    modalBulkActionsLoading,
    selectAll,
    toggleSelect,
    applyBulkTransition,
    applyBulkDelegate,
    selectBulkAction
  }
}

export const getBulkLabel = (type, bulkAction) => {
  if (bulkAction.workflow) {
    return TranslationProvider.getTrans(`bulk_action_${type}_${bulkAction.workflow}_${bulkAction.name}`)
  }

  return TranslationProvider.getTrans(`bulk_action_${type}_${bulkAction.name}`)
}
